import React, { useEffect, useState } from "react";
import ToggleDetails from "./ToggleDetails";
import { useDispatch, useSelector } from "react-redux";
import General from "./General";
import { useLocation, useNavigate } from "react-router-dom";
import {getAuthorization} from "../../../../axios/AxiosAut";
import {
  setItemDetails,
  setItemsSuppliers,
  setItemsTransactions,
  SetCurrentID
} from "../../../../redux/slices/item/itemSlice";
import ItemsSupplierTableData from "./ItemsSupplierTableData";
import ItemsTransactionDetailsTableData from "./ItemsTransactionDetailsTableData";
import BOM from "./BOM";
import Swal from "sweetalert2";
import { setProducts } from "../../../../redux/slices/product/productSlice";
import { setAPIDetailsItemsTable } from "../../../../redux/slices/statistics/statisticSlice";

function DetailsOfItem() {
  const dispatch = useDispatch();
  const Status = useSelector((state) => state.item.ToggleStatus);
  const ItemDetails = useSelector((state) => state.item.ItemDetails);
  const location = useLocation();
  const Navigate = useNavigate();

  const Permissions = useSelector((state) => state.user.userPermissions);
  const editproduct = Permissions.find((o) => o.codename === "change_products");
  const deleteproduct = Permissions.find(
    (o) => o.codename === "delete_products"
  );

  const { state } = location;
  const ID = state;

  useEffect(() => {
    getAuthorization()
      .get(`product/get_product/${ID}/`)
      .then((res) => {
        console.log("ItemDetails", res.data);
        dispatch(setItemDetails(res.data));
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, []);

  useEffect(() => {
    getAuthorization()
    .get(`product/get_product_suppliers/${ID}/`)
    .then((res) => {
      console.log("ItemsSuppliers", res.data);
      dispatch(setItemsSuppliers(res.data));
      dispatch(SetCurrentID(ID));
    })
    .catch((err) => {
      console.log("err", err);
    });
  }, []);

  const getItemsList=()=>{
    getAuthorization()
    .get("product/all_products/")
    .then((res) => {
      setProducts(res.data);
      dispatch(setAPIDetailsItemsTable(res.data));
    })
    .catch((err) => {
      console.log("Error in getting products", err);
    });
  }

  const ItemDeleteHandler = () => {
    getAuthorization()
      .delete(`product/delete_item/${ID}/`)
      .then((res) => {
        console.log("Item Deleted", res);
      })
      .catch((err) => {
        console.log("Error in deleting the Item", err);
      });
      Swal.fire({
        position: "top-end",
        title: "Item Deleted!",
        showConfirmButton: false,
        timer: 3500,
        showClass: {
          popup: "animate__animated animate__fadeInRight",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutRight",
        },
        width: 300,
        color: "#FFFFFF",
        background: "#2A91D7",
        backdrop: `rgba(0,0,0,0)`,
      });
      getItemsList()
      Navigate("/dashboard/management/items");
  };

  const AssemblyDeleteHandler = () => {
    getAuthorization()
      .delete(`product/delete_item/${ID}/`)
      .then((res) => {
        console.log("Assembly Deleted", res);
      })
      .catch((err) => {
        console.log("Error in deleting the Assembly", err);
      });
      Swal.fire({
        position: "top-end",
        title: "Assembly Deleted!",
        showConfirmButton: false,
        timer: 3500,
        showClass: {
          popup: "animate__animated animate__fadeInRight",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutRight",
        },
        width: 300,
        color: "#FFFFFF",
        background: "#2A91D7",
        backdrop: `rgba(0,0,0,0)`,
      });
      getItemsList()
      Navigate("/dashboard/management/items");
  };

  return (
    <>
      <div className="flex flex-col container mt-2 mb-5 ml-5">
        <div>
          <h2 className="font-Montserrat text-xl font-bold text-black">
            Item Details
          </h2>
          <div className="border-b-2 border-blue-200 w-16"></div>
        </div>
        <div className="flex flex-row justify-center space-x-16 my-7">
          <div className="flex flex-row space-x-1">
            <h3 className="font-Roboto text-base text-gray-100">Name:</h3>
            <p className="font-Roboto text-base text-gray-500">
              {ItemDetails.name}
            </p>
          </div>
          <div className="flex flex-row space-x-1">
            <h3 className="font-Roboto text-base text-gray-100">Version:</h3>
            <p className="font-Roboto text-base text-gray-500">2.4</p>
          </div>
          <div className="flex flex-row space-x-1">
            <h3 className="font-Roboto text-base text-gray-100">Status:</h3>
            {ItemDetails.status === "active" ? (
              <p className="font-Roboto text-base text-green-100">Active</p>
            ) : null}
            {ItemDetails.status === "discontinued" ? (
              <p className="font-Roboto text-base text-red-600">Discontinued</p>
            ) : null}
          </div>
          <div className="flex flex-row space-x-1">
            <h3 className="font-Roboto text-base text-gray-100">Item Code:</h3>
            <p className="font-Roboto text-base text-gray-500">
              {" "}
              {ItemDetails.product_id}
            </p>
          </div>
        </div>
        <ToggleDetails />
        {Status === "General" ? <General /> : null}
        {Status === "Details" ? <ItemsSupplierTableData Id={ID} /> : null}
        {Status === "Transactions" ? (
          <ItemsTransactionDetailsTableData Id={ID} />
        ) : null}
        {Status === "Bom" ? <BOM Id={ID} /> : null}
        <div className="flex flex-row justify-around mt-10">
          <div className="flex flex-row">
            <button className="text-red-600 font-Montserrat font-medium text-lg"  onClick={() => Navigate("/dashboard/management/items")}
>
              Go Back
            </button>
          </div>
          <div className="flex flex-row space-x-8 my-7">

          {!deleteproduct === undefined ||
                            deleteproduct?.codename === "delete_products" ? (
            <div className="flex flex-row space-x-3">
              <div className="pt-2.5">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 12.6667H3.33333V11.3333H6V12.6667ZM7.964 9.976L10.0353 12.046L7.294 12.6667L7.964 9.976ZM16 6.08333L10.7347 11.414L8.6 9.27933L13.8653 3.94933L16 6.08333ZM12 12.03V14.6667H1.33333V2.66667H4L5.40133 4H8L9.33333 2.66667H12V3.94067L13.3333 2.59133V1.33333H11.3333C10.514 1.33333 9.88 0.610667 9.33333 0H4C3.45333 0.610667 2.81933 1.33333 2 1.33333H0V16H13.3333V10.68L12 12.03ZM6.66667 1.33333C7.03467 1.33333 7.33333 1.632 7.33333 2C7.33333 2.368 7.03467 2.66667 6.66667 2.66667C6.29867 2.66667 6 2.368 6 2C6 1.632 6.29867 1.33333 6.66667 1.33333Z"
                    fill="#1F78B4"
                  />
                </svg>
              </div>
              {ItemDetails.product_type === "assembly" ? (
              <button onClick={()=>AssemblyDeleteHandler()} className="text-blue-200 font-Montserrat font-medium text-lg" >
                Delete Assembly
              </button>
              ) :  
              <button onClick={()=>ItemDeleteHandler()} className="text-blue-200 font-Montserrat font-medium text-lg">
              Delete Items
            </button>
              }
            </div>
) : null}
            {!editproduct ===undefined ||  editproduct?.codename ===
              "change_products" ? (
            <div className="flex flex-row space-x-3">
              <div className="pt-2.5">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.38533 2.82133L0.958667 11.2473L0 16L4.75133 15.0413L13.1787 6.61467L9.38533 2.82133ZM2.47267 12.75L1.906 12.1833L9.33333 4.76667L9.89933 5.33267L2.47267 12.75ZM3.81133 14.0887L3.24467 13.522L10.672 6.10533L11.2387 6.672L3.81133 14.0887V14.0887ZM16 3.79267L14.1227 5.67133L10.3287 1.87733L12.206 0L16 3.79267Z"
                    fill="#1F78B4"
                  />
                </svg>
              </div>
              {ItemDetails.product_type === "assembly" ? (
              <button className="text-blue-200 font-Montserrat font-medium text-lg" onClick={() =>
                Navigate("/dashboard/management/items/edit-assembly", {state: ID})
              }>
                Edit Assembly
              </button>
              ) :
              <button className="text-blue-200 font-Montserrat font-medium text-lg" onClick={() =>
                Navigate("/dashboard/management/items/edit-item", {state: ID})
              }>
                Edit Item
              </button>
              }
            </div>
               ) : null
              }
            <div className="flex flex-row space-x-3">
              <div className="pt-2.5">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 7.99995H16M8 0V16"
                    stroke="#1F78B4"
                    stroke-width="2"
                  />
                </svg>
              </div>
              <button className="text-blue-200 font-Montserrat font-medium text-lg">
                Create Picking List
              </button>
            </div>
          
            <div className="flex flex-row space-x-1">
              <button className="font-Montserrat font-semibold text-white bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1.5 px-3 flex flex-grow">
                Start Assembly
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DetailsOfItem;
